//This file is used for maintain JavaScript functions that are bound to a particular scope or view
(function(module) {
  'use strict';
  module
    .controller('tripFieldsController', ['$scope', 'tripFields', '$stateParams', 'progressBar', 'ngDialog',
      'uiGridConstants', 'organizations', 'commonDialog', 'commonDialogMessage', '$q', '$state',
      'clientSelectService', 'agencySelectService',
      'toastFactory', 'authService',
      function($scope, tripFields, $stateParams, progressBar, ngDialog, uiGridConstants, organizations,
        commonDialog, commonDialogMessage, $q, $state, clientSelectService, agencySelectService, toastFactory,
        authService) {
        const progress = progressBar.getProgressBar();
        $scope.tripField = {
          Id: 0,
          Name: null,
          AgencyDefinition: null,
          OrganizationId: null,
          Required: false,
          FieldOption: {
            Id: 0,
            TripFieldId: 0,
            Name: null,
          },
        };
        $scope.isEdit = false;
        $scope.isNew = false;
        $scope.fieldOptionList = [{
          Id: 0,
          Name: '',
          TripFieldId: 0,
        }, ];
        $scope.isDetails = false;
        let selectedClientId = clientSelectService.getSelectedClient().id;
        // get trip field details by id for edit
        let id = $stateParams.id;
        if ((!!id)) {
          tripFieldDetailsById(id);
        }
        $scope.organizationSelId = clientSelectService.getSelectedClient().id;
        // Validate that filtered organization id is defined
        function validateOrganization() {
          const organization = clientSelectService.getSelectedClient();
          return organization.id != null && Number.isInteger(organization.id);
        }

        function tripFieldDetailsById(id) {
          progress.start();
          tripFields.getTripFieldById(id).then(function(response) {
            $scope.isEdit = true;
            $scope.isNew = false;
            let tripFieldContext = response.data;
            bindTripField(tripFieldContext);
          });
        };

        function bindTripField(tripFieldContext) {
          if (!!tripFieldContext) {
            $scope.tripField.Id = tripFieldContext.Id;
            $scope.tripField.OrganizationId = tripFieldContext.OrganizationId;
            $scope.tripField.Name = tripFieldContext.Name;
            $scope.tripField.AgencyDefinition = tripFieldContext.AgencyDefinition;
            $scope.tripField.Required = tripFieldContext.Required;
            $scope.fieldOptionList = ((!!tripFieldContext.TripFieldOptions.length) ? tripFieldContext.TripFieldOptions : [{
                Id: 0,
                Name: '',
                TripFieldId: tripFieldContext.Id,
              }, ]),
              $scope.organizationSelId = tripFieldContext.OrganizationId;
            bindOrganizationName(tripFieldContext.OrganizationId);
          }
        };

        function bindOrganizationName(organizationId) {
          organizations.getOrganizationById(organizationId).then(function(supportOrganization) {
            $scope.organization = supportOrganization.data;
          });
        };
        $scope.saveTripField = function() {
          if ($scope.tripFieldForm.$valid && !!$scope.organizationSelId) {
            let tripField = $scope.tripField;
            tripField.OrganizationId = $scope.organizationSelId;
            let promisePost = tripFields.addTripField(tripField);
            let fieldOptionList = $scope.fieldOptionList.filter(function(fieldOption) {
              return (!!fieldOption.Name);
            });
            progress.start();
            promisePost.then(function(tripFielddata) {
                if (!!fieldOptionList.length) {
                  let promisePostFieldOption = tripFields.addTripFieldOption(tripFielddata.data.Id,
                    fieldOptionList);
                  promisePostFieldOption.then(function() {
                      const dialogPost = ngDialog.open({
                        template: 'templates/partials/viewSuccessMsg.html',
                        className: 'ngdialog-theme-plain',
                        controller: ['$scope', function($scope) {
                          $scope.successMsg = commonDialogMessage.fieldNameSavedMessage;
                          $scope.strTitle = 'Add Trip Field Success';
                        }, ],
                      });
                      dialogPost.closePromise.then(function(data) {
                        $scope.clearAll();
                        $state.go('app.tripField');
                      });
                    }, function(err) {
                      if (err.status != 401) {
                        ngDialog.open({
                          template: 'templates/partials/viewErrorMsg.html',
                          className: 'ngdialog-theme-plain',
                          controller: ['$scope', function($scope) {
                            $scope.errMsg = err.statusText;
                            $scope.errTitle = 'Add Trip Field Error';
                          }, ],
                        });
                      }
                    })
                    .finally(function() {
                      progress.complete();
                    });
                } else {
                  const dialogPost = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                      $scope.successMsg = commonDialogMessage.fieldNameSavedMessage;
                      $scope.strTitle = 'Add Trip Field Success';
                    }, ],
                  });
                  dialogPost.closePromise.then(function(data) {
                    $scope.clearAll();
                    $state.go('app.tripField');
                  });
                }
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                      $scope.errMsg = err.statusText;
                      $scope.errTitle = 'Add Trip Field Error';
                    }, ],
                  });
                }
              })
              .finally(function() {
                progress.complete();
              });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function($scope) {
                $scope.errMsg = commonDialogMessage.tripFieldRequiredMessage;
                $scope.errTitle = 'Trip Field Error';
              }, ],
            });
          }
        };
        $scope.updateTripField = function() {
          if ($scope.tripFieldForm.$valid && !!$scope.organizationSelId) {
            let tripField = $scope.tripField;
            tripField.OrganizationId = $scope.organizationSelId;
            let fieldOptionList = $scope.fieldOptionList.filter(function(fieldOption) {
              return (!!fieldOption.Name);
            });
            progress.start();
            let promisePut = tripFields.updateTripField(tripField.Id, tripField);
            promisePut.then(function() {
                if (!!fieldOptionList.length) {
                  let promisePutOption = tripFields.updateTripFieldOption(tripField.Id, fieldOptionList);
                  promisePutOption.then(function() {
                    const dialogPut = ngDialog.open({
                      template: 'templates/partials/viewSuccessMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function($scope) {
                        $scope.successMsg = commonDialogMessage.fieldNameUpdatedMessage;
                        $scope.strTitle = 'Update Trip Field Success';
                      }, ],
                    });
                    dialogPut.closePromise.then(function(data) {
                      $state.go('app.tripField');
                    });
                  }, function(err) {
                    if (err.status != 401) {
                      ngDialog.open({
                        template: 'templates/partials/viewErrorMsg.html',
                        className: 'ngdialog-theme-plain',
                        controller: ['$scope', function($scope) {
                          $scope.errMsg = err.statusText;
                          $scope.errTitle = 'Add Trip Field Error';
                        }, ],
                      });
                    }
                  });
                } else {
                  const dialogPut = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                      $scope.successMsg = commonDialogMessage.fieldNameUpdatedMessage;
                      $scope.strTitle = 'Update Trip Field Success';
                    }, ],
                  });
                  dialogPut.closePromise.then(function(data) {
                    $state.go('app.tripField');
                  });
                }
              }, function(err) {
                if (err.status != 401) {
                  ngDialog.open({
                    template: 'templates/partials/viewErrorMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                      $scope.errMsg = err.statusText;
                      $scope.errTitle = 'Add Trip Field Error';
                    }, ],
                  });
                }
              })
              .finally(function() {
                progress.complete();
              });
          } else {
            ngDialog.open({
              template: 'templates/partials/viewErrorMsg.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function($scope) {
                $scope.errMsg = commonDialogMessage.tripFieldRequiredMessage;
                $scope.errTitle = 'Trip Field Required Message';
              }, ],
            });
          }
        };
        $scope.clearAll = function() {
          $scope.tripField = {};
          $scope.isEdit = false;
          $scope.isNew = false;
          $scope.organizationSelId = null;
          $scope.tripFieldForm.$setPristine();
          $scope.fieldOptionList = [{
            Id: 0,
            Name: '',
            TripFieldId: 0,
          }, ];
        };
        $scope.addFieldOption = function() {
          $scope.fieldOptionList.push({
            Id: 0,
            Name: '',
            TripFieldId: $scope.tripField.Id,
          });
        };
        $scope.removeFieldOption = function(index, optionId) {
          if (!!optionId) {
            const confirm = ngDialog.open({
              template: 'templates/partials/viewConfirm.html',
              className: 'ngdialog-theme-plain',
              controller: ['$scope', function($scope) {
                $scope.strTitle = 'Delete Field Option?';
                $scope.strMsg = 'Do you really want to delete this field option?';
              }, ],
            });
            confirm.closePromise.then(function(data) {
              if (data.value === 1) {
                tripFields.deleteTripFieldOption(optionId).then(function(del) {
                    let dialogDel = ngDialog.open({
                      template: 'templates/partials/viewSuccessMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function($scope) {
                        $scope.successMsg = commonDialogMessage.fieldOptionDeletedMessage;
                        $scope.strTitle = 'Delete Trip Field Option Success';
                      }, ],
                    });
                    dialogDel.closePromise.then(function(data) {
                      $scope.fieldOptionList.splice(index, 1);
                      if ($scope.fieldOptionList.length == 0) {
                        $scope.fieldOptionList.push({
                          Id: 0,
                          Name: '',
                          TripFieldId: $scope.tripField.Id,
                        });
                      }
                    });
                  }, function(err) {
                    if (err.status != 401) {
                      ngDialog.open({
                        template: 'templates/partials/viewErrorMsg.html',
                        className: 'ngdialog-theme-plain',
                        controller: ['$scope', function($scope) {
                          $scope.errMsg = err.statusText;
                          $scope.errTitle = 'Remove Trip Field Error';
                        }, ],
                      });
                    }
                  })
                  .finally(function() {
                    progress.complete();
                  });
              }
            });
          } else {
            if ($scope.fieldOptionList.length > 1) {
              $scope.fieldOptionList.splice(index, 1);
            } else {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: ['$scope', function($scope) {
                  $scope.errMsg = 'At least 1 field option is required.';
                  $scope.errTitle = 'Trip Field Required Message';
                }, ],
              });
            };
          };
        };
        // ui-grid code
        const paginationOptions = {
          pageNumber: 1,
          pageSize: 25,
          sort: null,
        };
        $scope.gridOptions = {
          paginationPageSizes: [5, 10, 25, 50],
          enableFiltering: true,
          enableGridMenu: false,
          paginationPageSize: 25,
          useExternalPagination: true,
          useExternalSorting: false,
          enableColumnResizing: true,
          enableRowSelection: true,
          enableSelectAll: false,
          enableRowHeaderSelection: false,
          multiSelect: false,
          columnDefs: [{
            name: 'Name',
            visible: true,
            enableHiding: false,
            displayName: 'Field Name',
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
            sort: {
              direction: uiGridConstants.ASC,
              priority: 0,
            },
          }, {
            name: 'AgencyDefinition',
            visible: true,
            displayName: 'Agency Definition',
            enableHiding: false,
            enableSorting: true,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: true,
            enableColumnResizing: true,
            maxWidth: 250,
          }, {
            name: 'Required',
            displayName: 'Required',
            visible: true,
            enableSorting: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            maxWidth: 250,
            enableColumnResizing: true,
            cellTemplate: ' <span ng-show="row.entity.Required" style="padding-left: 5px;">Yes</span> <span ng-hide="row.entity.Required" style="padding-left: 5px;">No</span>',
            filter: {
              type: uiGridConstants.filter.SELECT,
              selectOptions: [{
                value: 'true',
                label: 'Yes',
              }, {
                value: 'false',
                label: 'No',
              }, ],
            },
          }, {
            name: 'TripFieldOptions',
            visible: true,
            displayName: 'Field Option',
            enableHiding: false,
            enableSorting: false,
            sortDirectionCycle: [uiGridConstants.ASC, uiGridConstants.DESC],
            enableFiltering: false,
            cellTemplate: '<div style="padding-left: 5px;"> {{grid.appScope.setFieldOptions(row.entity.TripFieldOptions)}}</div>',
            enableColumnResizing: true,
          }, ],
          onRegisterApi: function(gridApi) {
            $scope.gridApi = gridApi;
            $scope.gridApi.core.on.sortChanged($scope, function(grid, sortColumns) {
              if (!sortColumns.length) {
                paginationOptions.sort = null;
              } else {
                paginationOptions.sort = sortColumns[0].sort.direction;
              }
            });
            gridApi.pagination.on.paginationChanged($scope, function(newPage, pageSize) {
              paginationOptions.pageNumber = newPage;
              paginationOptions.pageSize = pageSize;
              setGridData();
            });
            // Show organization details on grid row selection.
            gridApi.selection.on.rowSelectionChanged($scope, function(row) {
              $scope.rowSelectingId = row.entity.Id;
              if (row.isSelected) {
                $scope.rowSelecting = true;
              } else {
                $scope.rowSelecting = false;
              }
            });
          },
        };
        // Validate that filtered organization id is defined
        function validateAgencyAndClientSelection() {
          const agency = agencySelectService.getSelectedAgency();
          const client = clientSelectService.getSelectedClient();
          return {
            agencyValid: agency.id != null && Number.isInteger(agency.id),
            clientValid: client.id != null && Number.isInteger(client.id),
          };
        }

        function setGridData() {
          if (authService.getLoginMember().Role === 3) {
            getTripFields();
          } else {
            const valid = validateAgencyAndClientSelection();
            if (valid.agencyValid && valid.clientValid) {
              selectedClientId = clientSelectService.getSelectedClient().id;
              $scope.organizationSelId = selectedClientId;
              if (!!selectedClientId) {
                getTripFieldsbyOrg(selectedClientId);
              }
            } else if (valid.agencyValid) {
             // toastFactory.toast_info('Please select a client.');
            } else {
             // toastFactory.toast_info('Please select an agency and then client.');
            }
          }
        };

        function getTripFieldsbyOrg(organizationId) {
          progress.start();
          organizations.getOrganizationById(organizationId).then(function(response) {
              let tripFieldsContext = response.data.TripFields;
              const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
              $scope.gridOptions.data = tripFieldsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
              $scope.gridOptions.totalItems = tripFieldsContext.length;
              if (!tripFieldsContext.length) {
                //\\toastFactory.toast_warn(commonDialogMessage.tripFieldNoResultMessage);
              }
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function($scope) {
                    $scope.errMsg = err.statusText;
                    $scope.errTitle = 'Trip Field Error';
                  }, ],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        }

        function getTripFields() {
          progress.start();
          tripFields.getTripFields().then(function(response) {
              let tripFieldsContext = response.data;
              const firstRow = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
              $scope.gridOptions.data = tripFieldsContext.slice(firstRow, firstRow + paginationOptions.pageSize);
              $scope.gridOptions.totalItems = tripFieldsContext.length;
              if (!tripFieldsContext.length) {
                //\\toastFactory.toast_warn(commonDialogMessage.tripFieldNoResultMessage);
              }
            }, function(err) {
              if (err.status != 401) {
                ngDialog.open({
                  template: 'templates/partials/viewErrorMsg.html',
                  className: 'ngdialog-theme-plain',
                  controller: ['$scope', function($scope) {
                    $scope.errMsg = err.statusText;
                    $scope.errTitle = 'Trip Field Error';
                  }, ],
                });
              }
            })
            .finally(function() {
              progress.complete();
            });
        }
        setGridData();
        $scope.setFieldOptions = function(optionList) {
          let optionName = '';
          optionName = optionList.reduce(function(option, name) {
            return option += name.Name + ' , ';
          }, optionName);
          return optionName.substring(0, optionName.length - 2);
        };
        $scope.view = function() {
          if (!!$scope.rowSelectingId) {
            tripFieldDetailsById($scope.rowSelectingId);
          }
          ngDialog.open({
            template: 'templates/partials/viewTripField.html',
            className: 'ngdialog-theme-plain',
            scope: $scope,
          });
        };
        $scope.deleteTripField = function() {
          const confirm = ngDialog.open({
            template: 'templates/partials/viewConfirm.html',
            className: 'ngdialog-theme-plain',
            controller: ['$scope', function($scope) {
              $scope.strTitle = 'Delete Trip Field?';
              $scope.strMsg = 'Do you really want to delete this trip field?';
            }, ],
          });
          confirm.closePromise.then(function(data) {
            if ($scope.rowSelectingId && data.value === 1) {
              progress.start();
              tripFields.deleteTripField($scope.rowSelectingId).then(function(response) {
                  const dialog = ngDialog.open({
                    template: 'templates/partials/viewSuccessMsg.html',
                    className: 'ngdialog-theme-plain',
                    controller: ['$scope', function($scope) {
                      $scope.successMsg = 'The trip field has been succesfully deleted.';
					            $scope.strTitle = 'Delete Trip Field Success';
                    }, ],
                  });
                  dialog.closePromise.then(function(data) {});
                }, function(err) {
                  if (err.status != 401) {
                    const dialog = ngDialog.open({
                      template: 'templates/partials/viewErrorMsg.html',
                      className: 'ngdialog-theme-plain',
                      controller: ['$scope', function($scope) {
                        $scope.errMsg = err.statusText;
                        $scope.errTitle = 'Delete Trip Field Error'; //PLACE HOLDER
                      }, ],
                    });
                    dialog.closePromise.then(function(data) {});
                  }
                })
                .finally(function() {
                  progress.complete();
                  setGridData();
                });
            }
          });
        };
        $scope.edit = function() {
          $state.go('app.editTripField', {
            id: $scope.rowSelectingId,
          });
        };
        // Watch clientSelectService for changes to getFilteredOrganization() output -- expensive, calls getFilteredOrganization many times during $digest cycle
        $scope.$watch(function() {
          return clientSelectService.getSelectedClient();
        }, function(newValue, oldValue) {
          if (newValue !== oldValue) {
            $scope.organizationSelId = null;
            $scope.gridOptions.data = [];
            $scope.gridOptions.totalItems = 0;
            setGridData();
          }
        }, true);
      },
    ]);
})(angular.module('obex'));


// WEBPACK FOOTER //
// ./client/js/controllers/tripFieldsController.js